import React from "react";
import { Column } from "@ant-design/charts";
import { Skeleton } from "@pankod/refine-antd";
import { useCustom } from "@pankod/refine-core";
import ENV from "utils/env";
import { extractPaginated } from "../utils";

type RawProduct = { productName: string; count: string };

interface TopProductsColumnProps {
  dateRange: [string, string];
  shopCode: string | null;
  limit?: number;
}

export const TopProductsColumn: React.FC<TopProductsColumnProps> = ({
  dateRange,
  shopCode,
  limit = 10,
}) => {
  const { data: response, isFetching } = useCustom({
    url: `${ENV.API_URL}/api/analytics/stats/top-products`,
    method: "get",
    config: {
      query: {
        startDate: dateRange[0],
        endDate: dateRange[1],
        page: 1,
        limit,
        ...(shopCode ? { shopCode } : {}),
      },
    },
    queryOptions: { retry: 0 },
  });

  if (isFetching) return <Skeleton active />;

  const { items } = extractPaginated<RawProduct>(response?.data);
  const data = items.slice(0, 20).map((r) => ({
    product: r.productName || "Bilinmeyen",
    count: parseInt(r.count, 10),
  }));

  if (data.length === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const config = {
    data,
    xField: "product",
    yField: "count",
    color: "#459cd3",
    style: {
      maxWidth: 40,
    },
    label: {
      text: (d: any) => String(d.count),
      position: "inside" as const,
      style: { fill: "#fff", fontWeight: 600 },
    },
    axis: {
      x: {
        labelAutoRotate: true,
        labelFormatter: (text: string) =>
          text.length > 20 ? text.substring(0, 18) + "…" : text,
      },
    },
    tooltip: {
      title: (d: any) => d.product,
      items: [{ channel: "y", name: "Tıklanma" }],
    },
  };

  return <Column {...config} />;
};
